<rotec-modal-v2
  [darkMode]="true"
  title="Unbalance tolerance calculation according to DIN ISO 21940-11 not available"
>
  <ng-container ngProjectAs="modal-main">
    <div translate>
      The unbalance tolerance calculation according to DIN ISO 21940-11 is not available for this
      support setting. Please calculate the unbalance tolerance manually, split it up between the
      two correction planes and enter it in the User Defined Unbalance Tolerance.
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button translate rotec-button-active dark (click)="close()">
      {{ 'COMMON_Continue' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
